import type { PlansResponse } from '../types'

// Fallback when /api/subscription/plans is unreachable. Keep in sync with
// SubscriptionPlanCatalog on the backend and Stripe Dashboard prices.
export const FALLBACK_PLANS: PlansResponse = {
  currency: 'PLN',
  plans: [
    { code: 'PRO5_1', includedDrivers: 1,   monthlyNet: 50,  extraDriverNet: 40, prepaid6mNet: 270,  prepaid12mNet: 550 },
    { code: 'PRO5',   includedDrivers: 5,   monthlyNet: 150, extraDriverNet: 30, prepaid6mNet: 810,  prepaid12mNet: 1440 },
    { code: 'PRO20',  includedDrivers: 20,  monthlyNet: 450, extraDriverNet: 22, prepaid6mNet: 2430, prepaid12mNet: 4320 },
    { code: 'PRO50',  includedDrivers: 50,  monthlyNet: 650, extraDriverNet: 15, prepaid6mNet: 3510, prepaid12mNet: 6240 },
    { code: 'PRO100', includedDrivers: 100, monthlyNet: 750, extraDriverNet: 8,  prepaid6mNet: 4050, prepaid12mNet: 7200 },
    { code: 'PRO250', includedDrivers: 250, monthlyNet: 950, extraDriverNet: 4,  prepaid6mNet: 5130, prepaid12mNet: 9120 },
  ],
  upgradeThresholds: [
    { fromCode: 'PRO5',   toCode: 'PRO20',  atDriverCount: 14 },
    { fromCode: 'PRO20',  toCode: 'PRO50',  atDriverCount: 33 },
    { fromCode: 'PRO50',  toCode: 'PRO100', atDriverCount: 57 },
    { fromCode: 'PRO100', toCode: 'PRO250', atDriverCount: 126 },
  ],
}

export const recommendPlan = (driverCount: number, plans: PlansResponse['plans']): string => {
  for (const p of plans) {
    if (p.includedDrivers >= driverCount) return p.code
  }
  return plans[plans.length - 1].code
}
